import { Directive, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';

export const queryStringToJSON = (input) => {
  var pairs = input.split('&');
  var result = {};
  pairs.forEach(function (pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });

  return JSON.parse(JSON.stringify(result));
}

export const jsonToQueryString = (params) => {
  return Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

export function cloneArray(items) {
  if (items && typeof items == "object" && items.length) {
    return items.map(item => Object.assign({}, item));
  }
  else {
    return [];
  }
}

export function jsonParse(str) {
  try {
    if (typeof str == 'string')
      return JSON.parse(str);
    else
      return str;
  } catch (e) {

    if (typeof str == 'object')
      return str;
    else
      return str;
  }
}


export function findInvalidControls(form_group, control_list, translate, notification_svc, invalid_field_subject?) {
  const invalid = [];
  const controls = form_group.controls;
  const invalid_controls = [];
  const invalid_field = [];
  let control_names = Object.keys(control_list);
  if (controls && Object.keys(controls)) {
    for (const name in controls) {
      try {
        if (controls[name].invalid) {
          invalid.push(name);
          invalid_controls.push(controls[name]);
        }
      } catch (err) {

      }
    }
  }


  let found = 0;
  control_names.forEach(control_name => {
    if (!found) {
      if (control_name == invalid[0]) {
        invalid_field.push(control_name);
        // try {

        // }
        // catch (err) {

        // }
        // translate.get(control_list.control_name).subscribe(res => {
        let res = control_list[control_name];
        if (invalid_controls[0] && invalid_controls[0].errors && invalid_controls[0].errors.required) {
          notification_svc.error(stripHtmlTags(res) + " is required", "Cancel", 3000)
        }
        else {
          notification_svc.error(stripHtmlTags(res) + " is invalid", "Cancel", 3000)
        }
        found = 1;
        // })
      }
    }
  })
  return invalid;
}

export function markFormGroupTouched(formGroup: UntypedFormGroup) {
  (<any>Object).values(formGroup.controls).forEach(control => {
    control.markAsTouched();
    if (control.controls) {
      markFormGroupTouched(control);
    }
  });
}

export function stripHtmlTags(str) {
  try {
    return str.replace(/(<([^>]+)>)/ig, "");
  }
  catch (err) {
    return str;
  }
}
export const special_keys = [
  8,
  9,
  13,
  16,
  17,
  18,
  19,
  20,
  27,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  45,
  46,
  91,
  92,
  144,
  145,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  120,
  121,
  122,
  123
];


export const supported_file_types_document = [
  {
    code: 1,
    title: '.pdf'
  },
  {
    code: 1,
    title: '.doc'
  },
  {
    code: 1,
    title: '.docx'
  }
]


export const supported_file_types_image = [
  {
    code: 1,
    title: '.jpg'
  },
  {
    code: 1,
    title: '.jpeg'
  },
  {
    code: 1,
    title: '.png'
  }
]


export function checkMobileScreen() {
  if (screen.width < 500) {
    return true;
  }
  return false;
}


@Directive({
  selector: '[ngInit]'
})
export class NgInitDirective implements OnInit {

  @Input() func;

  constructor() {

  }

  ngOnInit() {
    setTimeout(() => {
      if (this.func) {
        this.func();
      }
    }, 1000)
  }
}


export function setDefaultCountryCode(list: [], form: UntypedFormGroup, control_name, id_property, default_section_property_name, other_control_validation?: []) {

  let user
  try {
    user = JSON.parse(localStorage.getItem('getipobject'))
  }
  catch (err) {
    user = (localStorage.getItem('getipobject'))
  }
  if (user && user.country) {
    list.forEach(country => {
      if (country[default_section_property_name] == user.country) {
        form.controls[control_name].patchValue(country[id_property]);
      }
    })
  }
  else {
    form.controls[control_name].patchValue('+91')
  }

}
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';

@Pipe({
  name: 'SafeUrlPipe'
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
export function getInvalidFields(form_group: UntypedFormGroup, translate, notification_srv, json_root_property, do_not_translate?) {
  if (form_group && form_group.controls) {
    let all_controls = Object.keys(form_group.controls);
    for (let i = 0; i < all_controls.length; i++) {
      if (form_group.controls[all_controls[i]].errors) {
        let err
        if (form_group.controls[all_controls[i]].errors) {
          if (form_group.controls[all_controls[i]].errors.required) {
            err = 'ERROR.is_required'
          }
          else if (form_group.controls[all_controls[i]].errors.maxLength) {
            err = 'ERROR.max_length';
          }
          else if (form_group.controls[all_controls[i]].errors.minLength) {
            err = 'ERROR.minimum_length';
          }
          else if (form_group.controls[all_controls[i]].errors.min) {
            err = 'ERROR.min_value'
          }
          else if (form_group.controls[all_controls[i]].errors.max) {
            err = 'ERROR.max_value'
          }
          else {
            err = 'ERROR.invalid_input'
          }
          if (!do_not_translate) {
            translate.get([json_root_property + all_controls[i], err]).subscribe(res => {
              let message;
              let cname = res[json_root_property + all_controls[i]];
              let ename = res[err]
              message = cname + ' ' + ename
              notification_srv.error(message, "Close", 5000);
            })
          }
          else {
            translate.get([err]).subscribe(res => {
              let message;
              let cname = all_controls[i];
              let ename = res[err]
              message = cname + ' ' + ename
              notification_srv.error(message, "Close", 5000);
            })
          }



        }
        break;
      }
    }
    all_controls.forEach(key => {

    })
  }
}

export const country_language_map = [
  {
    countrycode: 'AD',
    lngcode: 'CA',
  },
  {
    countrycode: 'AE',
    lngcode: 'AR',
  },
  {
    countrycode: 'IN',
    lngcode: 'EN',
  },
]

export function removeDuplicate(list, id_property) {
  return list.filter((v, i) => list.findIndex(item => item[id_property] == v[id_property]) === i)
}

export function sortListSeq(list, sort_selector_property) {
  return list.sort((a, b) => a[sort_selector_property].toString().localeCompare(b[sort_selector_property].toString()));
}


export const website_validation = '^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$'


export function localToUTC(date: Date) {
  let d = new Date(date).toUTCString();
  return moment.parseZone(d).format('YYYY-MM-DD HH:mm:ss')
}

export function formatDate(date: Date) {
  return moment.parseZone(date).format('YYYY-MM-DD')
}
export function formatDateL(date: Date) {
  return moment.parseZone(date).format('YYYY-MM-DD')
}
export function formatDateTime(date: Date) {
  return moment.parseZone(date).format('YYYY-MM-DD HH:mm:ss')
}
export function localToUTCDate(date) {
  let d = new Date(date).toUTCString();
  return moment.parseZone(d).format('YYYY-MM-DD')

}

export function toUTCDate(date) { //convert UTC to local dont go on name
  if (date) {
    return new Date(date + ' UTC')
  }
  else {
    return null
  }
}

export function formatTextareaContent(str) {
  if (str) {
    try {
      return str.replace(/\\n/g, "\r\n")
    }
    catch (err) {
      return str;
    }

  }
  else {
    return ''
  }
}

export function removeDuplicateFromArray(list) {
  return list.filter((element, i) => i === list.indexOf(element))
}

export const input_excelsheet_only = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.ms-excel.sheet.macroEnabled.12";
export const input_pdf_only = "application/pdf";
export const input_pdf_docs_only = "application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
export const file_data_base = 'data:application/pdf;base64,'

export function parseSelectedProperties(data, list) {
  if (list && list.length) {
    list.forEach(item => {
      data[item] = jsonParse(data[item]);
    })
    return data;
  }
  else {
    return data;
  }
}

export function parseResponseJSON(data) {
  if (data) {
    let keys = Object.keys(data);
    keys.forEach(k => {
      data[k] = jsonParse(data[k])
    })
    return data;
  }
  else {
    return {}
  }
}

export function prepareAccessRights(data) {
  let access_rights: any = {}
  if (data && data.length) {
    data.forEach(right => {
      access_rights[right.code] = right;
    })
    return access_rights;
  }
  else {
    return {}
  }
}

export function arrayToObject(data, selector) {
  let access_rights: any = {}
  if (data && data.length) {
    data.forEach(right => {
      access_rights[right[selector]] = right;
    })
    return access_rights;
  }
  else {
    return {}
  }
}
export function prepareFieldConfigFlags(data, form?, opForm?) {
  let access_rights: any = {}
  if (data && data.length) {
    data.forEach(right => {
      let rightsd = prepareDynamicValidationScript(right);
      access_rights[right.shortCode] =
      {
        shortCode: right.shortCode,
        validationScript: rightsd,
        mandatory: rightsd && rightsd.mandatory
      }

      if (form && right.validationScript && right.validationScript != '' && right.shortCode && right.shortCode != '') {
        try {
          setDynamicValidators(rightsd, form, right.shortCode, opForm)
        }
        catch (err) {
          console.log(err)
        }
      }
    })
    return access_rights;
  }
  else {
    return {}
  }
}
export function setDynamicValidators(field, form, formControlName, opForm) {
  try {
    // form.get(field.title).setValidators([Validators.required, Validators.minLength(field.minLength), Validators.maxLength(field.maxLength), Validators.pattern(field.pattern), Validators.min(field.min), Validators.max(field.max)])

    let validators = [];
    //Min and Max length validation
    try {
      form.get([formControlName]).clearValidators();
      form.get([formControlName]).updateValueAndValidity();
      if (opForm) {
        try {
          opForm.get([formControlName]).clearValidators();
          opForm.get([formControlName]).updateValueAndValidity();
        }
        catch (err) {
        }

      }
    }
    catch (err) {
      console.log(err)
    }

    if (field.minLength != '' && field.minLength != null) {
      validators.push(Validators.minLength(eval(field.minLength)));
    }

    if (field.maxLength != '' && field.maxLength != null) {
      validators.push(Validators.maxLength(eval(field.maxLength)));
    }

    if (field.pattern && field.pattern != '') {

      validators.push(Validators.pattern(field.pattern));
    }


    //Min and Max value validation

    if (field.min != '' && field.min != null) {
      validators.push(Validators.min(eval(field.min)));
    }

    if (field.max != '' && field.max != null) {
      validators.push(Validators.max(eval(field.max)));
    }

    if (field.mandatory != '' && field.mandatory && field.mandatory != '0') {
      validators.push(Validators.required);
    }
    console.log(formControlName)
    form.get([formControlName]).setValidators(validators);
    form.get([formControlName]).updateValueAndValidity();
    console.log(form.get([formControlName]))
    if (opForm) {
      try {
        opForm.get([formControlName]).setValidators(validators);
        opForm.get([formControlName]).updateValueAndValidity();
      }
      catch (err) {
      }

    }
    console.log(form.get([formControlName]))
  }
  catch (err) {
    console.log(err + '' + formControlName)
    console.log(err)

  }
}
export function prepareDynamicValidationScript(field) {
  if (field.validationScript && field.validationScript != '') {
    try {
      let objects = field.validationScript.split(",");
      objects.forEach(o => {
        let arr = o.split("@");
        if (arr && arr.length > 1) {
          field[arr[0].trim()] = arr[1].trim();
          console.log(arr[1].trim())
        }
      })
      return field
    }
    catch (err) {
      console.log(err)
      return field;
    }
  }
  else {
    return null
  }
}

export function checkEditAccessRights(check_data, all_rights, prepared_access_rights, module_code) {
  let session = sessionStorage.getItem('u');
  let userId = 0
  if (session) {
    try {
      let user = JSON.parse(atob(session));
      if (user && user.userId) {
        userId = user.userId
      }
    }
    catch (er) {
      console.log(er)
    }

  }

  if (all_rights && all_rights.icrAdmin) { //check for icrAdmin
    return 3;
  }
  else if (check_data && check_data.crUserId == userId && prepared_access_rights[module_code]) {

    return prepared_access_rights[module_code].myself; //check for my self
  }
  // else if (all_rights && prepared_access_rights && prepared_access_rights[module_code] && (prepared_access_rights[module_code].myself == 2 || prepared_access_rights[module_code].myself == 3)) {
  // }
  else {
    if (check_data && all_rights && all_rights.teamUsers && all_rights.teamUsers.length && prepared_access_rights && prepared_access_rights[module_code]) {
      let index = all_rights.teamUsers.indexOf(check_data.crUserId);
      if (index > -1) { //check if not for my self but for my team
        return prepared_access_rights[module_code].myteam;
      }
      else {
        return prepared_access_rights && prepared_access_rights[module_code] && prepared_access_rights[module_code].myself || 0; //no access_rights
      }
    }
    else {
      return prepared_access_rights && prepared_access_rights[module_code] && prepared_access_rights[module_code].myself || 0; //no access_rights
    }
  }
}


import { HttpEvent, HttpResponse, HttpEventType, HttpProgressEvent } from "@angular/common/http";

export function isHttpResponse<T>(
  event: HttpEvent<T>
): event is HttpResponse<T> {
  return event.type === HttpEventType.Response;
}

export function isHttpProgressEvent(
  event: HttpEvent<unknown>
): event is HttpProgressEvent {
  return (
    event.type === HttpEventType.DownloadProgress ||
    event.type === HttpEventType.UploadProgress
  );
}

import { Observable } from "rxjs";
import { distinctUntilChanged, scan } from "rxjs/operators";

export interface Upload {
  progress: number;
  state: "PENDING" | "IN_PROGRESS" | "DONE";
}

export function upload(): (
  source: Observable<HttpEvent<unknown>>
) => Observable<Upload> {
  const initialState: Upload = { state: "PENDING", progress: 0 };
  const reduceState = (state: Upload, event: HttpEvent<unknown>): Upload => {
    if (isHttpProgressEvent(event)) {
      return {
        progress: event.total
          ? Math.round((100 * event.loaded) / event.total)
          : state.progress,
        state: "IN_PROGRESS",
      };
    }
    if (isHttpResponse(event)) {
      return {
        progress: 100,
        state: "DONE",
      };
    }
    return state;
  };
  return (source) =>
    source.pipe(
      scan(reduceState, initialState),
      distinctUntilChanged(
        (a, b) => a.state === b.state && a.progress === b.progress
      )
    );
}
export function getLoginUserID() {
  let session = sessionStorage.getItem('u');
  let userId = 0
  if (session) {
    try {
      let user = JSON.parse(atob(session));
      if (user && user.userId) {
        userId = user.userId
      }
    }
    catch (er) {
      console.log(er)
    }
    return userId
  }
  else {
    return 0;
  }
}

export function jsonDeepParse(str) {
  try {
    if (str) {
      str = jsonParse(str);
      if (str && str.length && typeof str == 'object') {
        str.forEach(element => {
          element = jsonDeepParse(element);
        });
      }
      else if (str && typeof str == 'object') {
        let keys = Object.keys(str);
        if (keys && keys.length) {
          keys.forEach(key => {
            str[key] = jsonDeepParse(str[key]);
          });
        }
      }
      return str;
    }
    else {
      return str;
    }
  }
  catch (e) {
    return str;
  }
}

@Pipe({
  name: 'UtcToLocalTimeEmail'
})
export class UTCtoLocalPipeEmail implements PipeTransform {
  // transform(val: any): any {
  //     try {
  //         new Date(val);
  //         super.transform(val, "d-MMM-yyyy h:mm a")
  //         return val;
  //     }
  //     catch (e) {
  //         return null;
  //     }
  transform(val: any): Date {
    try {
      if (val != '1900-01-01T00:00:00') {
        new Date(val);
        return val;
      }
      return null;
    }
    catch (e) {
      return null;
    }
    // return val;

    // return val;
  }
}
export function prepareGridColumns(list, defaultWidth?, tableCode?) {

  if (tableCode) {
    let res = jsonParse(sessionStorage.getItem('access_rights'));
    if (res && res['data'] && res['data'].defaultConfig && res['data'].defaultConfig.tableViewSettings) {
      let tableSettings = jsonParse(res['data'].defaultConfig.tableViewSettings)
      if (tableSettings && tableSettings.length) {
        for (let i = 0; i < tableSettings.length; i++) {
          let table = tableSettings[i];
          if (table.tableCode == tableCode) {
            list.forEach(col => {
              try {
                col['title'] = col['columnName'];
                col['data_type'] = col['dataType'];
                col['field_name'] = col['method'] || null;
                col['width'] = col['width'] || defaultWidth || 90;
                col['cell_template'] = col['cellTemplate'];
                col['color_property'] = col['colorProperty'];
                col['code'] = col['code'] || col['columnId'];
                col['cell_class'] = col['cellClass'];
                // if (table['displayRefColumnName'] == col['property']) {
                //   col['style'] = table;
                // }
                col['style'] = table;
              }
              catch (err) {
                console.log(err)
              }


              // col['enable_sort'] = col['enableSort'] || 1
              // col['sort'] = col['enableSort'] || 0
            });
            break;
          }
        }
        console.log(list)
        return list;
      }
      else {
        list.forEach(col => {
          try {
            col['title'] = col['columnName'];
            col['data_type'] = col['dataType'];
            col['field_name'] = col['method'] || null;
            col['width'] = col['width'] || defaultWidth || 90;
            col['cell_template'] = col['cellTemplate'];
            col['color_property'] = col['colorProperty'];
            col['code'] = col['code'] || col['columnId'];
            col['cell_class'] = col['cellClass']
          }
          catch (err) {
            console.log(err)
          }

          // col['enable_sort'] = col['enableSort'] || 1
          // col['sort'] = col['enableSort'] || 0
        });
        return list;
      }
    }
    else {
      list.forEach(col => {
        try {
          col['title'] = col['columnName'];
          col['data_type'] = col['dataType'];
          col['field_name'] = col['method'] || null;
          col['width'] = col['width'] || defaultWidth || 90;
          col['cell_template'] = col['cellTemplate'];
          col['color_property'] = col['colorProperty'];
          col['code'] = col['code'] || col['columnId'];
          col['cell_class'] = col['cellClass']
        }
        catch (err) {
          console.log(err)
        }

        // col['enable_sort'] = col['enableSort'] || 1
        // col['sort'] = col['enableSort'] || 0
      });
      return list;
    }

  }
  else {
    list.forEach(col => {
      try {
        col['title'] = col['columnName'];
        col['data_type'] = col['dataType'];
        col['field_name'] = col['method'] || null;
        col['width'] = col['width'] || defaultWidth || 90;
        col['cell_template'] = col['cellTemplate'];
        col['color_property'] = col['colorProperty'];
        col['code'] = col['code'] || col['columnId'];
        col['cell_class'] = col['cellClass']
      }
      catch (err) {
        console.log(err)
      }

      // col['enable_sort'] = col['enableSort'] || 1
      // col['sort'] = col['enableSort'] || 0
    });
    return list;
  }


}


export function prepareGridData(list) {
  if (list && list.length) {
    list.map(data => {
      if (data.extendedData && data.extendedData != '') {
        data.extendedData = jsonParse(data.extendedData);
        if (data.extendedData) {
          Object.keys(data.extendedData).forEach(k => {
            data[k] = data.extendedData[k] || '';
          })
          return data;
        }
        else {
          return data;
        }
      }
      else {
        return data;
      }
    })
    return list;
  }
  else {
    return []
  }
}
export const storage_url = 'https://storage.googleapis.com/ezeone/icanrefer/';


export function formDataToJSON(formData) {
  var object = {};
  formData.forEach((value, key) => {
    // Reflect.has in favor of: object.hasOwnProperty(key)
    if (!Reflect.has(object, key)) {
      object[key] = value;
      return;
    }
    if (!Array.isArray(object[key])) {
      object[key] = [object[key]];
    }
    object[key].push(value);
  });
  var json = JSON.stringify(object);
  return json;
}
export function scrollToElement(id) {
  let el = document.getElementById(id)
  el.scrollTo({
    top: el.offsetTop,
    behavior: 'smooth'
  })
}

@Pipe({
  name: 'DynamicFieldConfigProcessing'
})
export class DynamicFieldConfigProcessing implements PipeTransform {
  transform(value, form_group, control_name, default_field_config_access, field_config_access, short_code, validators, change_detector): any {
    // console.log(value)
    // console.log(default_field_config_access)
    // console.log(field_config_access)
    if (default_field_config_access) {
      let field_details = default_field_config_access[short_code + '' + control_name];
      // console.log(field_details)
      if (field_details && field_details.validationScriptUI && field_details.validationScriptUI.mandatory_with_eval) {
        try {
          eval(field_details.validationScriptUI.mandatory_with_eval);
          console.log(field_config_access['RES_lastName'])
          change_detector.detectChanges();
        }
        catch (err) {
          console.log(err)
        }
      }
    }
    return value;
    // let out_status = true;
    // if (value && field && field.UIValidationObjStruct) {
    //   if (field.UIValidationObjStruct.mandatory && field.UIValidationObjStruct.mandatory.condition) {
    //     try {
    //       field.UIValidationObjStruct.mandatory.value = eval(field.UIValidationObjStruct.mandatory.condition);
    //     }
    //     catch (err) {

    //     }
    //     // setValidatorsV3(form_group, field);
    //   }
    //   else {

    //   }
    //   if (field.UIValidationObjStruct.disabled && field.UIValidationObjStruct.disabled.condition) {
    //     try {
    //       field.UIValidationObjStruct.disabled.value = eval(field.UIValidationObjStruct.disabled.condition);
    //     }
    //     catch (err) {

    //     }
    //     // setValidatorsV3(form_group, field);
    //   }
    //   else {

    //   }

    //   if (field.UIValidationObjStruct.hide && field.UIValidationObjStruct.hide.condition) {
    //     try {
    //       field.UIValidationObjStruct.hide.value = eval(field.UIValidationObjStruct.hide.condition);
    //     }
    //     catch (err) {

    //     }
    //     // setValidatorsV3(form_group, field);
    //   }
    //   else {

    //   }


    // }
    // else {
    //   return out_status;
    // }
    // return out_status;
  }
}

export function isMobile(){
 try{
  if (window.matchMedia("(max-width: 767px)").matches) {
    // User is using a mobile device with a responsive screen
    return true
  } else {
    // User is not using a mobile device with a responsive screen
   return false
  }
 }
 catch(err){
  return false
 }
}


